import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import MediaCategoryFormLayer from "../components/MediaCategoryFormLayer";

const MediaCategoryFormPage = () => {
    return (
        <MasterLayout>
            <MediaCategoryFormLayer />
        </MasterLayout>
    );
};

export default MediaCategoryFormPage;
